import { fabric } from 'fabric';
import set from 'lodash-es/set';

const CLOUDINARY_PROXY_URL = 'https://res.cloudinary.com/ludusone/image/fetch/';

const LudusIframe = fabric.util.createClass(fabric.Group, {
  type: 'ludusIframe',
  lockUniScaling: false,
  lockScalingFlip: true,
  minSize: 100,

  /**
   * Class constructor
   *
   * @param iconImageURL
   * @param options
   */
  initialize(iconImageURL, options = {}) {
    this._initialized = false;

    set(options, 'top', options.top || 0);
    set(options, 'left', options.left || 0);

    this._backgroundObject = new fabric.Rect({
      height: 640,
      width: 960,
      top: 0,
      left: 0,
      originX: 'center',
      originY: 'center',
      stroke: 'rgba(0,0,0,0.5)',
      strokeWidth: 1,
      fill: 'rgba(245,245,245,0.5)',
    });

    this._iconObject = new fabric.ImageAsync(iconImageURL, {
      top: 0,
      left: 0,
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
    });

    this.callSuper(
      'initialize',
      [this._backgroundObject, this._iconObject],
      options,
    );
    this.ludus.ludusIframeVersion = '2.0';
    this._initialized = true;
  },

  _positionBackground() {
    const scaleX = this.getObjectScaling().scaleX;
    const scaleY = this.getObjectScaling().scaleY;
    this._backgroundObject.set({
      width: this.width * scaleX - 1,
      height: this.height * scaleY - 1,
      top: 0,
      left: 0,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY,
    });
  },

  _positionIcon() {
    if (this._widthOrHeightBelow(this.minSize)) {
      this.remove(this._iconObject);
    } else {
      this.addIfRemoved(this._iconObject);
    }
    this._iconObject.set({
      scaleX: 1 / this.getObjectScaling().scaleX,
      scaleY: 1 / this.getObjectScaling().scaleY,
    });
  },

  _positionChildren() {
    this._iconObject.setCoords();

    if (this._backgroundObject) {
      this._positionBackground();
    }
    if (this._iconObject) {
      this._positionIcon();
    }
  },

  _widthOrHeightBelow(value) {
    return (
      this._getScaledWidthInGroup() < value ||
      this._getScaledHeightInGroup() < value
    );
  },

  _getScaledWidthInGroup() {
    return (this.group ? this.group.get('scaleX') : 1) * this.getScaledWidth();
  },

  _getScaledHeightInGroup() {
    return (this.group ? this.group.get('scaleY') : 1) * this.getScaledHeight();
  },

  addIfRemoved(object) {
    if (!object.group) {
      this.add(object);
    }
    return this;
  },

  render(ctx) {
    this._positionChildren();
    this.callSuper('render', ctx);
  },
});

LudusIframe.fromObject = (object, callback) => {
  const options = fabric.util.object.clone(object, true);

  const iconUrl =
    CLOUDINARY_PROXY_URL +
    encodeURIComponent(
      'https://s3.amazonaws.com/ludus-blocks/icons/iframe.png',
    );
  if (callback) {
    const iframe = new LudusIframe(iconUrl, options);
    callback(iframe);
  }
};

export default LudusIframe;
